import { render, staticRenderFns } from "./ProductLoyalty.vue?vue&type=template&id=bc42e2f6&scoped=true&"
import script from "./ProductLoyalty.vue?vue&type=script&lang=js&"
export * from "./ProductLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./ProductLoyalty.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductLoyalty.vue?vue&type=style&index=1&id=bc42e2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc42e2f6",
  null
  
)

export default component.exports